import { h } from 'preact';
import PropTypes from 'prop-types';

import { elementTypesList } from './props-list';

const DEFAULT_CHECKBOX_TYPE = ['checkbox'];
const DEFAULT_IS_DISABLED = false;
const DEFAULT_IS_CHECKED = false;

const Checkbox = ({
  children,
  id,
  elementType = DEFAULT_CHECKBOX_TYPE,
  isDisabled = DEFAULT_IS_DISABLED,
  isChecked = DEFAULT_IS_CHECKED,
  onClick,
}) => {
  let classNames = `c-forms__${elementType}`;
  if (isDisabled) {
    classNames += ' is-disabled';
  }
  return (
    <div className={classNames}>
      <input id={id} type="checkbox" checked={isChecked && 'checked'} onClick={onClick} />
      <label className="c-forms__label c-forms__label--clickable" htmlFor={id}>
        <span />
      </label>
      <label className="c-forms__label c-forms__label--not-clickable">{children}</label>
    </div>
  );
};

Checkbox.propTypes = {
  children: PropTypes.any.isRequired,
  id: PropTypes.string.isRequired,
  elementType: PropTypes.arrayOf(PropTypes.oneOf(elementTypesList)),
  isDisabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default Checkbox;
